function dispatchCartEvent(data, cartItemsId) {
  if (data[cartItemsId]) {
    const parserItems = new DOMParser().parseFromString(
      data[cartItemsId],
      "text/html"
    );

    document.dispatchEvent(
      new CustomEvent("cart:update-html", {
        detail: {
          freeShippingHTML: parserItems.querySelector("free-shipping"),
          cartItemsHTML: parserItems.querySelector("cart-items"),
          cartSubtotalHTML: parserItems.querySelector("cart-subtotal"),
          cartAsideHTML: parserItems.querySelector("cart-aside"),
          cartHeaderHTML: parserItems.querySelector("cart-header"),
        },
      })
    );
  }
}

const announcementBar = document.querySelector(".announcement-bar-section");

function setAnnouncementBarHeight() {
  if (!announcementBar) return;

  document.documentElement.style.setProperty(
    "--announcement-bar-height",
    announcementBar.clientHeight + "px"
  );
}

window.setTimeout(() => {
  setAnnouncementBarHeight();
}, 2000);

window.addEventListener("resize", setAnnouncementBarHeight, {
  passive: true,
});

function globalHandleScroll() {
  document.documentElement.classList.toggle(
    "is-scrolled",
    window.scrollY >
      document.documentElement.style
        .getPropertyValue("--announcement-bar-height")
        .replace("px", "")
  );
  if (window.matchMedia("(min-width: 990px)").matches) {
    if(document.querySelector(".section-header").classList.contains("scrolled-past-header")) {
      document.querySelector(".search-modal").classList.add("page-scrolled");
    }
    else {
      document.querySelector(".search-modal").classList.remove("page-scrolled");
    }
  }
}

globalHandleScroll();

window.addEventListener("scroll", globalHandleScroll, {
  passive: true,
});

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

/**
 * QuantityOffers
 *
 * This component is used to handle the quantity offers on the product page.
 * This component will dispatch a custom event when the quantity offer changes.
 * For best results, this component should be used in conjunction with the quantity-input component and a matching discount per quantity offer.
 */
class QuantityOffers extends HTMLElement {
  /**
   * Constructor
   *
   * @returns {void}
   */
  constructor() {
    super();
    this.quantityOffers = this.querySelectorAll('input[name="Quantity Offer"]');
  }

  /**
   * Connected Callback
   *
   * @returns {void}
   */
  connectedCallback() {
    this.init();
  }

  /**
   * Determine if the debug mode is enabled for the component instance
   *
   * @returns {boolean}
   */
  allowDebug() {
    return this.classList.contains('debug');
  }

  /**
   * Init
   *
   * @returns {void}
   */
  init() {
    if (this.allowDebug()) console.log('QuantityOffers init', this.quantityOffers, this);
    this.setEventListeners();
    // the page will render with a default quantity offer selected, so we need to trigger the change event to update the quantity offer
    const selectedQuantityOffer = this.getSelectedQuantityOffer();
    if(selectedQuantityOffer) {
      this.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      // find the first quantity offer in the component and check it
      const firstQuantityOffer = this.quantityOffers[0];
      if(firstQuantityOffer) {
        firstQuantityOffer.checked = true;
        this.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  /**
   * Set Event Listeners
   *
   * @returns {void}
   */
  setEventListeners() {
    this.addEventListener('change', () => {
      this.updateQuantityOffer();
    });
  }

  /**
   * Update Quantity Offer
   *
   * @returns {void}
   */
  updateQuantityOffer() {
    if (this.allowDebug()) console.log('QuantityOffers updateQuantityOffer', this);
    const selectedQuantityOffer = this.getSelectedQuantityOffer();
    if(!selectedQuantityOffer) return;
    if(this.allowDebug()) console.log('QuantityOffers selectedQuantityOffer', selectedQuantityOffer);

    // Update URL with offer parameter
    this.updateURL(selectedQuantityOffer);

    this.dispatchEvent(new CustomEvent('quantity-offers:change', {
      bubbles: true,
      detail: {
        value: selectedQuantityOffer.value,
        label: selectedQuantityOffer.label,
      },
    }));
  }

  /**
   * Get Selected Quantity Offer
   *
   * @returns {HTMLElement}
   */
  getSelectedQuantityOffer() {
    return Array.from(this.quantityOffers).find(quantityOffer => quantityOffer.checked);
  }

  /**
   * Get Selected Quantity Offer Value
   *
   * @returns {string}
   */
  getSelectedQuantityOfferValue() {
    const selectedQuantityOffer = this.getSelectedQuantityOffer();
    return selectedQuantityOffer ? selectedQuantityOffer.value : null;
  }

  /**
   * Get Selected Quantity Offer Label
   *
   * @returns {string}
   */
  getSelectedQuantityOfferLabel() {
    const selectedQuantityOffer = this.getSelectedQuantityOffer();
    return selectedQuantityOffer ? selectedQuantityOffer.label : null;
  }

  /**
   * Update URL with offer parameter
   *
   * @param {HTMLElement} selectedQuantityOffer - The selected quantity offer element
   * @returns {void}
   */
  updateURL(selectedQuantityOffer) {
    if (!selectedQuantityOffer || !selectedQuantityOffer.dataset.quantityOfferId) return;

    const url = new URL(window.location);
    const offerId = selectedQuantityOffer.dataset.quantityOfferId;

    // Update or add the offer parameter
    url.searchParams.set('offer', offerId);

    // Update the browser URL without triggering a page reload
    window.history.replaceState({}, '', url.toString());

    if (this.allowDebug()) {
      console.log('QuantityOffers URL updated with offer:', offerId, url.toString());
    }
  }
}

customElements.define("quantity-offers", QuantityOffers);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach(
      (button) =>
        button.closest('search-clear')?.classList.contains('search-clear-menu')
          ? button.addEventListener("click", this.onMenuSearchCloseButtonClick.bind(this))
          : button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const menuDrawerContainer = detailsElement.closest(
      ".menu-drawer-container"
    );
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        menuDrawerContainer &&
          menuDrawerContainer.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`, "filter-open");
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mobileBreakpoint = "(max-width: 749px)";
    this.mainDetailsToggle.classList.remove("menu-opening", "submenu-open");

    if (
      !this.hasAttribute("data-facets-drawer") ||
      window.matchMedia(this.mobileBreakpoint).matches
    ) {
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening", "submenu-open");
      });
    }
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
      document.body.classList.remove("filter-open");
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeWithoutAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  onMenuSearchCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeMenuSearch(detailsElement);
  }

  closeMenuSearch(detailsElement) {
    const menuDrawerContainer = detailsElement.closest(
      ".menu-drawer-container"
    );
    const menuCloseButton = detailsElement.querySelector("icon-close-alt");
    menuCloseButton.classList.remove("icon-close-alt-visible");
    menuCloseButton.style.display = "inline-flex";
  }

  closeSubmenu(detailsElement) {
    const menuDrawerContainer = detailsElement.closest(
      ".menu-drawer-container"
    );
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    let hasSubmenuOpen = menuDrawerContainer?.querySelector(".submenu-open");
    if (!hasSubmenuOpen) {
      menuDrawerContainer &&
        menuDrawerContainer.classList.remove("submenu-open");
    }
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeWithoutAnimation(detailsElement);
  }

  closeWithoutAnimation(detailsElement) {
    detailsElement.removeAttribute("open");
    if (detailsElement.closest("details[open]")) {
      trapFocus(
        detailsElement.closest("details[open]"),
        detailsElement.querySelector("summary")
      );
    }
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.querySelector(".search-modal").classList.add("with-menu-drawer-open");
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
    document.querySelector(".search-modal").classList.remove("with-menu-drawer-open");
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(
          this.header.getBoundingClientRect().bottom - this.borderOffset
        )}px`
      );
    document.documentElement.style.setProperty(
      "--viewport-height",
      `${window.innerHeight}px`
    );
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus();
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (
        deferredElement.nodeName == "VIDEO" &&
        deferredElement.getAttribute("autoplay")
      ) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderPosition = { left: 0, x: 0 };

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.mouseDownHandlerRef = this.mouseDownHandler.bind(this);
    this.mouseMoveHandlerRef = this.mouseMoveHandler.bind(this);
    this.mouseUpHandlerRef = this.mouseUpHandler.bind(this);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.slider.addEventListener("mousedown", this.mouseDownHandlerRef);
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;

    this.attachDotClickHandlers();
    this.update();
  }

  attachDotClickHandlers() {
    const indicatorContainer = this.querySelector('.slider-dots');
    if (!indicatorContainer) return;

    indicatorContainer.querySelectorAll('span').forEach((dot) => {
      dot.onclick = () => this.goToSlide(parseInt(dot.dataset.index));
    });
  }

  goToSlide(i) {
    const targetScrollLeft = this.sliderItemsToShow[i].offsetLeft;
    this.slider.scrollTo({
      left: targetScrollLeft,
      behavior: 'smooth'
    });
    this.updateActiveDot(i);
  }

  updateActiveDot(i) {
    const indicatorContainer = this.querySelector('.slider-dots');
    if (!indicatorContainer) return;

    const wrapper = indicatorContainer.querySelector('.slider-dots-wrapper');
    const dots = wrapper ? Array.from(wrapper.children) : Array.from(indicatorContainer.children);

    // Update active state
    dots.forEach(dot => dot.classList.remove('active'));
    if (dots[i]) {
      dots[i].classList.add('active');
    }

    // Handle sliding for larger amount of dots
    if (wrapper) {
      const styles = getComputedStyle(indicatorContainer);
      const dotWidth = parseFloat(styles.getPropertyValue('--dot-width')) || 50;
      const gap = parseFloat(styles.getPropertyValue('--dot-gap')) || 6;
      const maxVisible = parseInt(styles.getPropertyValue('--max-visible-dots')) || 6;

      if (dots.length > maxVisible) {
        // Start sliding once we're past the last visible dot
        let offset = 0;
        if (i >= maxVisible - 1) {
          offset = (i - maxVisible + 1) * (dotWidth + gap);
        }

        // Don't slide past the end
        const maxOffset = (dots.length - maxVisible) * (dotWidth + gap);
        offset = Math.min(offset, maxOffset);

        wrapper.style.transform = `translateX(-${offset}px)`;
      } else {
        wrapper.style.transform = '';
      }
    }
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
      this.updateActiveDot(this.currentPage - 1);
    }

    this.sliderItems.forEach((sliderItem, index) => {
      if (this.currentPage === index + 1 && !this.hasAttribute('data-disable-dynamic-height')) {
        this.slider.style.maxHeight = `${sliderItem.offsetHeight}px`;
      }

      sliderItem.classList.toggle('slider__slide--current', (this.currentPage === index + 1))
    });

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const target = event.currentTarget || event.target;
    const step = target.dataset.step || 1;
    this.slideScrollPosition =
      target.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  mouseDownHandler(event) {
    this.slider.style.cursor = 'grabbing';

    this.sliderPosition = {
      left: this.slider.scrollLeft,
      x: event.clientX,
    };

    document.addEventListener('mousemove', this.mouseMoveHandlerRef);
    document.addEventListener('mouseup', this.mouseUpHandlerRef);
  };

  mouseMoveHandler(event) {
    const dx = event.clientX - this.sliderPosition.x;

    this.slider.scrollLeft = this.sliderPosition.left - dx;
  };

  mouseUpHandler() {
    this.slider.style.cursor = 'grab';
    this.slider.style.removeProperty('user-select');

    document.removeEventListener('mousemove', this.mouseMoveHandlerRef);
    document.removeEventListener('mouseup', this.mouseUpHandlerRef);
  };
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class AnnouncementBarSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll(".announcement-bar__slide"));
    if (this.slides.length < 2) return;

    this.slidesContainer = this.querySelector(".announcement-bar__slides");
    this.bar = this.closest(".announcement-bar");
    this.index = 0;
    this.speed = Number(this.dataset.speed || 5) * 1000;
    this.autoplayEnabled = this.dataset.autoplay === "true";
    this.timer = null;

    this.onPause = () => this.pause();
    this.onResume = () => this.play();
    this.onFocusOut = (event) => {
      if (!this.bar.contains(event.relatedTarget)) this.play();
    };

    this.bar.addEventListener("mouseenter", this.onPause);
    this.bar.addEventListener("mouseleave", this.onResume);
    this.bar.addEventListener("focusin", this.onPause);
    this.bar.addEventListener("focusout", this.onFocusOut);

    if (this.autoplayEnabled) this.play();
  }

  disconnectedCallback() {
    this.pause();
    if (!this.bar) return;

    this.bar.removeEventListener("mouseenter", this.onPause);
    this.bar.removeEventListener("mouseleave", this.onResume);
    this.bar.removeEventListener("focusin", this.onPause);
    this.bar.removeEventListener("focusout", this.onFocusOut);
  }

  play() {
    if (!this.autoplayEnabled || this.slides.length < 2) return;

    this.pause();
    this.slidesContainer?.setAttribute("aria-live", "off");
    this.timer = setInterval(() => {
      this.goTo((this.index + 1) % this.slides.length);
    }, this.speed);
  }

  pause() {
    clearInterval(this.timer);
    this.timer = null;
    this.slidesContainer?.setAttribute("aria-live", "polite");
  }

  goTo(index) {
    this.index = index;

    for (const [i, slide] of this.slides.entries()) {
      const active = i === index;

      slide.classList.toggle("is-active", active);
      slide.setAttribute("aria-hidden", String(!active));

      for (const link of slide.querySelectorAll("a")) {
        if (active) {
          link.removeAttribute("tabindex");
        } else {
          link.setAttribute("tabindex", "-1");
        }
      }
    }

    const activeSlide = this.slides[index];

    if (!activeSlide || !this.bar) return;

    if (activeSlide.dataset.background) {
      this.bar.style.background = activeSlide.dataset.background;
    }

    if (activeSlide.dataset.color) {
      this.bar.style.color = activeSlide.dataset.color;
    }

    if (typeof setAnnouncementBarHeight === "function") {
      setAnnouncementBarHeight();
    }
  }
}

customElements.define("announcement-bar-slider", AnnouncementBarSlider);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateVariantTitle();

    if (!this.currentVariant.available) {
      this.toggleAddButton(true, "", false);
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateMedia();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    let prodItems = document.querySelectorAll(`.product__media-grid .product--item`);
    if(prodItems != null){
        prodItems.forEach((item) => {
          if(window.innerWidth >= 750){
            if(item.dataset.mediaId == this.currentVariant.featured_media.id){
              window.scrollTo({top: `${item.offsetTop}`, behavior: 'smooth'});
            }
          }
        })
    }

    const color =
      this.currentVariant[
        `option${parseInt(this.dataset.colorOptionIndex) + 1}`
      ];

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );

    const productMedia = document.querySelector('product-media');

    if (productMedia) {
      if (!this.dataset.variantTextSelectors) {
        productMedia.setActiveMedia(this.currentVariant.featured_media.id);
      }
    }

    mediaGalleries.forEach((mediaGallery) => {
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      );
      if (color) {
        const handle = color.replace(/\s+/g, "-").toLowerCase();
        mediaGallery.dispatchEvent(
          new CustomEvent("colorChanged", {
            detail: {
              color: handle,
            },
          })
        );
      }
    });

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter((variant) => {
      return this.querySelector(":checked").value === variant.option1;
    });
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections

        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`
        );

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === ""
          );

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        );
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          ""
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const bisButton = productForm.querySelector('[data-bis-button]');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.classList.remove('hidden');
      addButton.removeAttribute("disabled");
      bisButton?.classList.add('hidden');
      addButtonText.textContent = window.variantStrings.addToBag;
    }

    if (modifyClass && disable) {
      addButton.classList.add('hidden');
      bisButton?.classList.remove('hidden');
      bisButton?.setAttribute('data-variant-id', this.currentVariant.id);
    } else {
      addButton.classList.remove('hidden');
      bisButton?.classList.add('hidden');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  updateVariantTitle() {
    const variantTitleElements = document.querySelectorAll('[data-variant-title]');

    if (!variantTitleElements) return;
    variantTitleElements.forEach((variantTitleElement) => {
      variantTitleElement.textContent = this.currentVariant.title;
    });
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.selectors = {
      slider: '.swiper',
    };

    this.settings = {
      elements: {
        slider: this.querySelector(this.selectors.slider),
      },
      instances: {
        slider: null,
      },
      options: {
        slider: {
          initialSlide: 0,
          slidesPerView: 2.8,
          spaceBetween: 10,
          centerInsufficientSlides: true,
          navigation: {
            prevEl: this.querySelector('.swiper-button-prev'),
            nextEl: this.querySelector('.swiper-button-next'),
          }
        },
      },
    };
  }

  connectedCallback() {
    if (!this.settings.elements.slider)
      return;
    this.settings.instances.slider = new Swiper(
      this.settings.elements.slider,
      this.settings.options.slider,
    );
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

class StackedCards extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[data-slider]');
    this.slides = this.querySelectorAll('[data-slide]');
    this.slidesCounter = this.slides.length;

    // Don't initialize if only one slide
    if (this.slidesCounter <= 1) {
      this.classList.add('stacked-cards--disabled');
      return;
    }

    this.nextBtn = this.querySelector('[data-next-btn]');
    this.prevBtn = this.querySelector('[data-prev-btn]');
    this.autoplayBtn = this.querySelector('[data-toggle-autoplay]');
    this.autoplayStatus = this.slider.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.slider.dataset.speed);
    this.autoplayTimeout = null;
    this.isAnimating = false;
  }

  connectedCallback() {
    if (this.slidesCounter <= 1) return;

    this.attachEvents();
    if (this.autoplayStatus) {
      this.autoplay();
    }
  }

  attachEvents() {
    this.nextBtn?.addEventListener('click', () => {
      if (!this.isAnimating) this.nextSlide();
    });
    this.prevBtn?.addEventListener('click', () => {
      if (!this.isAnimating) this.prevSlide();
    });
    this.nextBtn?.addEventListener('click', this.resetAutoplayTime.bind(this));
    this.prevBtn?.addEventListener('click', this.resetAutoplayTime.bind(this));
    this.autoplayBtn?.addEventListener('click', this.toggleAutoplay.bind(this));
  }

  toggleAutoplay() {
    this.autoplayStatus = !this.autoplayStatus;
    this.autoplayBtn.classList.toggle('paused', !this.autoplayStatus);

    if (this.autoplayStatus) {
      this.autoplay();
    } else {
      clearTimeout(this.autoplayTimeout);
    }
  }

  autoplay() {
    clearTimeout(this.autoplayTimeout);
    this.autoplayTimeout = setTimeout(() => {
      if (this.autoplayStatus && !this.isAnimating) {
        this.nextSlide();
      }
    }, this.autoplaySpeed);
  }

  resetAutoplayTime() {
    if (this.autoplayStatus) {
      this.autoplay();
    }
  }

  nextSlide() {
    if (this.isAnimating) return;
    this.isAnimating = true;

    const firstSlide = this.slides[0];
    firstSlide.classList.add('is-transform');

    setTimeout(() => {
      this.slider.appendChild(firstSlide);
      firstSlide.classList.remove('is-transform');
      this.slides = this.querySelectorAll('[data-slide]');
      this.isAnimating = false;

      if (this.autoplayStatus) {
        this.autoplay();
      }
    }, 250);
  }

  prevSlide() {
    if (this.isAnimating) return;
    this.isAnimating = true;

    const lastSlide = this.slides[this.slidesCounter - 1];
    lastSlide.classList.add('is-transform-prev');
    this.slider.prepend(lastSlide);

    setTimeout(() => {
      lastSlide.classList.remove('is-transform-prev');
      this.slides = this.querySelectorAll('[data-slide]');
      this.isAnimating = false;

      if (this.autoplayStatus) {
        this.autoplay();
      }
    }, 250);
  }
}

customElements.define("stacked-cards", StackedCards);

function changeHeaderColorScheme(colorScheme) {
  const header = document.querySelector(".header-wrapper");

  header.classList.forEach((classValue) => {
    if (classValue.startsWith("color-background-")) {
      header.classList.remove(classValue);
    }
  });

  header.classList.add(colorScheme);
}

function getRecentlyViewedProducts() {
  let products = [];
  const cookie = Cookies.get('recently_viewed_products');

  if (cookie) {
    products = JSON.parse(cookie);
  }

  return products;
}

function addRecentlyViewedProduct(productHandle, limit = 6) {
  let products = getRecentlyViewedProducts();
  const index = products.indexOf(productHandle);

  if (index > -1) {
    products.splice(index, 1);
  }

  products.unshift(productHandle);

  products = products.slice(0, limit);

  Cookies.set('recently_viewed_products', JSON.stringify(products), { expires: 30, path: '/' });
}

/**
 * Patched in for deploy ticket DCB-479 to cover Codacy flag.
 * Product template renders will have a `data-template-product` attribute on the body.
 * After the addRecentlyViewedProduct function is defined, we will call it and send the page's product handle if applicable.
 */
if (document.body.dataset.templateProduct) {
  addRecentlyViewedProduct(document.body.dataset.templateProduct);
}

window.ajaxCart = {};
window.ajaxCart.load = function () {
  window.theme.toggleCart();
}

// Add class to body after 8 seconds, fixed the loading glitch
window.addEventListener("load", () => {
  document.querySelector('.header__icons .search-modal__form').classList.remove("loading-glicth-fix");
});

document.addEventListener("click", function(e) {
  let predictive_block = document.querySelector("[data-predictive-search]");
  let search_block = document.querySelector(".search-modal__form");
  const iconClose = document.querySelector("icon-close-alt");
  if (!predictive_block.contains(e.target) & !search_block.contains(e.target)){
    document.querySelector("icon-close-alt").classList.remove("icon-close-alt-visible"); /* predictive search menu */
    document.querySelector("icon-close-alt").style.display = "inline-flex"; /* predictive search menu */
  }
  if(iconClose && (iconClose === e.target || iconClose.contains(e.target))){
    document.querySelectorAll(".menu-drawer-container summary").forEach((el) => {
      if(el.closest('details').hasAttribute("open")) {
        el.closest('details').removeAttribute("open");
        el.closest('details').classList.remove("menu-opening");
      }
    })
    document.querySelectorAll(".menu-drawer-container .has-submenu").forEach((el) => {
      if(el.classList.contains("submenu-open")) {
        el.classList.remove("submenu-open");
      }
    })
    document.querySelector(".menu-drawer-container").classList.remove("menu-opening");
    document.querySelector(".menu-drawer-container").classList.remove("submenu-open");
    document.querySelector(".menu-drawer-container").removeAttribute("open");
    document.querySelector(".menu-drawer-container>summary").setAttribute("aria-expanded", "false");
    document.querySelector(".header__icons .header__search details[open] .search-modal.modal__content.with-menu-drawer-open")?.classList.remove("with-menu-drawer-open");
    const bodyClasses = document.body.classList;
    if (bodyClasses.contains('overflow-hidden-tablet')) {
      bodyClasses.remove('overflow-hidden-tablet');
    }
    if (bodyClasses.contains('overflow-hidden-mobile')) {
      bodyClasses.remove('overflow-hidden-mobile');
    }
  }
});
